import { Component, OnDestroy, ViewChild, } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectorCertificate } from '@app/certificates/manage/manage.reducer';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ICertificateData } from '@app/certificates/manage/manage';
import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { environment } from '@env/environment';
import { ActionProfilePlanGet } from '@app/profile/profile-remaining-count/profile-plan.actions';

@Component({
  selector: 'cloud-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnDestroy {

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  certs: ICertificateData[];
  unsubscribe$: Subject<void> = new Subject<void>();
  isInitialLoadLoading = true;
  readonly icons = iconCodes;
  requestTabSelected = false
  ordersTabSelected = false;

  constructor(
    private store: Store<any>,
  ) {
    this.store
      .select(selectorCertificate)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(certs => this.certs = certs);
    this.store.dispatch(new ActionProfilePlanGet());
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  loadedData(e: boolean) {
    this.isInitialLoadLoading = e;
    this.tabGroup.realignInkBar();
  }

  onTabChange(e: MatTabChangeEvent) {
    if (e.index === 1) { // executed when the second tab is selected
      this.requestTabSelected = true
    } else if (e.index === 2) { // executed when the third tab is selected
      this.ordersTabSelected = true;
    }

    // TO DO: setting- orders selected value- to be removed when using the new API
  }

  displayOrderHistoryTab() {
    return !environment.hideOrders;
  }
}
